import {
  LAB_LIST_REQUEST,
  LAB_LIST_SUCCESS,
  LAB_LIST_FAIL,
} from "../../constants/patientConstants/labConstants.js";

const initialState = { labs: [] };

export const labReducer = (state = initialState, action) => {
  switch (action.type) {
    case LAB_LIST_REQUEST:
      return { ...state, loading: true };
    case LAB_LIST_SUCCESS:
      return { loading: false, labs: action.payload };
    case LAB_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
